define('modules/editor/models/elements/button',['require','exports','module','./base'],function(require, exports, module) {
  "use strict";
  var BaseElement = require("./base");
  var ButtonElement = BaseElement.extend({
    name: "element:button",
    defaultNameKey:"button",
    defaultPropertyGroups: [],
    geometryProperty: "button:geometry",
    propertyGroups: [
      { name: "button:geometry",
        defaults: { width: 150, height: 50, top: 10, left: 10 }
      },
      {
        name: "idclass",
        defaults: {
          "id": "",
          "className": ""
        }
      },
      {
        name: "action",
        defaults: { url: "", target: ""}
      },
      {
        name: "label",
        defaults: {
          text: "Click me!!!!",
          fontStyle: "normal",
          fontFamily: "Arial",
          fontSize: 16
        }
      },
      {
        name: "button:style",
        defaults: {}
      }
    ],
  });

  module.exports = ButtonElement;
});

